export enum HaiStatusEnum {
  starting = 'starting',
  running = 'running',
  stopped = 'stopped',
  failed = 'failed',
}

export enum HaiSpecTypeEnum {
  advanced = 'advanced',
  basic = 'basic',
}

export enum originEnum {
  normal = 'normal',
  haiOriginCs = 'haiOriginCs',
  haiOriginHai = 'haiOriginHai',
}
